import React from 'react'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import s from './VehicleSettingsBox.less'

import classNames from 'classnames'
import { useSelector } from 'react-redux'
import {
  TAG_CLICK_TRAVEL_OPTIONS_CAR_VEHICLE,
  TAG_CLICK_TRAVEL_OPTIONS_MOTORBIKE_VEHICLE
} from '../analytics/analytics.tagids.constants'
import { changePreferredOptions } from '../../store/itineraryOptions/itineraryOptions.actions'
import {
  selectCritAirId,
  selectFuelList,
  selectModeMetadata,
  selectPreferredFuel,
  selectPreferredVehicle,
  selectVehicleList,
  selectVehicleOwn
} from '../../store/itineraryOptions/itineraryOptions.selectors'
import { SELECTION } from '../analytics/ClickTagsService'
import NumericInput from '../genericComponents/NumericInput'
import T from '../i18n/T'
import { useAction } from '../utils/react-redux'
import CritairSelect from './CritairSelect'
import {
  CRITAIR_ID,
  PREFERRED_FUEL_CONSUMPTION,
  PREFERRED_FUEL_ID,
  PREFERRED_FUEL_PRICE,
  PREFERRED_VEHICLE_ID,
  VEHICLE_OWN
} from './ItineraryOptions.constants'
import VehicleOwnedSwitcher from './VehicleOwnedSwitcher'

const tagConfig = {
  car: {
    [PREFERRED_VEHICLE_ID]: TAG_CLICK_TRAVEL_OPTIONS_CAR_VEHICLE
  },
  motorbike: {
    [PREFERRED_VEHICLE_ID]: TAG_CLICK_TRAVEL_OPTIONS_MOTORBIKE_VEHICLE
  }
}

export default function VehicleSettingsBox({ modeId, hasOwnSwitcher }) {
  const modeMetadata = useSelector(selectModeMetadata(modeId))
  const preferredVehicle = useSelector(selectPreferredVehicle(modeId))
  const preferredFuel = useSelector(selectPreferredFuel(modeId))
  const fuelList = useSelector(selectFuelList(modeId))
  const vehicleList = useSelector(selectVehicleList(modeId))
  const vehicleOwn = useSelector(selectVehicleOwn(modeId))
  const critAirStickers = modeMetadata?.transportMode?.critair
  const critAirId = useSelector(selectCritAirId(modeId))
  const execChangePreferredOptions = useAction(changePreferredOptions)
  const configureAndSendTag = useConfigureAndSendTag()

  const onPreferredOptionsChange = optionsToUpdate => event => {
    const value = event.target.value
    const tag = tagConfig?.[modeMetadata.id]?.[optionsToUpdate]
    if (tag) {
      configureAndSendTag({
        type: tag,
        tagInfo: {
          [SELECTION]: value
        }
      })
    }
    execChangePreferredOptions({
      modeId: modeMetadata.id,
      [optionsToUpdate]: value
    })
  }

  return (
    <div className={classNames(s.VehicleSettingsBox)}>
      <div className={s.VehicleSettingsBoxContent}>
        {hasOwnSwitcher && (
          <div>
            <VehicleOwnedSwitcher
              labelKey={`itinerary.options.own.${modeId}`}
              onChange={value => {
                onPreferredOptionsChange(VEHICLE_OWN)({ target: { value } })
              }}
              defaultValue={vehicleOwn}
            />
          </div>
        )}
        <div>
          <label>
            <T id={'itinerary.options.vehicle.type'} />
          </label>
          <span>
            <select value={preferredVehicle.id} onChange={onPreferredOptionsChange(PREFERRED_VEHICLE_ID)}>
              {(vehicleList || []).map(vehicle => (
                <option key={vehicle.id} value={vehicle.id}>
                  {vehicle.label}
                </option>
              ))}
            </select>
          </span>
        </div>
        <div>
          <label>
            <T id={'itinerary.options.vehicle.fuel'} />
          </label>
          <span>
            <select value={preferredFuel.id} onChange={onPreferredOptionsChange(PREFERRED_FUEL_ID)}>
              {(fuelList || []).map(fuel => (
                <option key={fuel.id} value={fuel.id}>
                  {fuel.label}
                </option>
              ))}
            </select>
            <NumericInput
              value={preferredFuel.price}
              step="0.1"
              onBlur={onPreferredOptionsChange(PREFERRED_FUEL_PRICE)}
            />
            <span>{preferredFuel.price_unit}</span>
          </span>
        </div>
        <div>
          <label>
            <T id={'itinerary.options.vehicle.consumption'} />
          </label>
          <span>
            <NumericInput
              value={preferredFuel.consumption}
              step="1"
              onBlur={onPreferredOptionsChange(PREFERRED_FUEL_CONSUMPTION)}
            />
            <span>{preferredFuel.consumption_unit}</span>
          </span>
        </div>
        {critAirStickers && (
          <div className={s.critAirLine}>
            <div>
              <T id={'itinerary.options.critair.label'} />
            </div>
            <CritairSelect
              critAirStickers={critAirStickers}
              value={critAirId}
              modeId={modeId}
              onChange={onPreferredOptionsChange(CRITAIR_ID)}
            />
          </div>
        )}
      </div>
    </div>
  )
}
